import { createAction } from "@reduxjs/toolkit";
import { AddressModel } from "src/components/core/AddressForm/utils";
import { ValidateAddressResponseProto_ValidationErrorReasonProto_Reason } from "@noom/noom-contracts/noom_contracts/billing/address/address_validation_service";

export const userAcceptedSuggestedAddress = createAction<{
  suggestedAddress: Partial<AddressModel>;
  isSameAsBillingAddress: boolean;
  shouldUpdateFormAddress: boolean;
}>("checkoutPhysicalAddress/userAcceptedSuggestedAddress");

export const userAcceptedMissingApartmentAddress = createAction(
  "checkoutPhysicalAddress/userAcceptedMissingApartmentAddress"
);

export const formAddressUpdatedWithSuggestedAddress = createAction(
  "checkoutPhysicalAddress/formAddressUpdatedWithSuggestedAddress"
);

export const suggestAddress = createAction<Partial<AddressModel>>(
  "checkoutPhysicalAddress/suggestAddress"
);

export const returnedInvalidAddress = createAction(
  "checkoutPhysicalAddress/returnedInvalidAddress"
);

export const setValidationErrorReasons = createAction<
  ValidateAddressResponseProto_ValidationErrorReasonProto_Reason[]
>("checkoutPhysicalAddress/setValidationErrorReasons");

export const failNoPOBoxValidation = createAction(
  "checkoutPhysicalAddress/failNoPOBoxValidation"
);

export const failShippingLocationValidation = createAction(
  "checkoutPhysicalAddress/failShippingLocationValidation"
);
